import { isEmojiSupported as n } from "is-emoji-supported";

function t() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Twemoji Country Flags";
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "https://cdn.jsdelivr.net/npm/country-flag-emoji-polyfill@0.1/dist/TwemojiCountryFlags.woff2";

  if (n("😊") && !n("🇨🇭")) {
    var _n = document.createElement("style");

    return _n.textContent = "@font-face {\n      font-family: \"".concat(t, "\";\n      unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067,\n        U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;\n      src: url('").concat(e, "') format('woff2');\n      font-display: swap;\n    }"), document.head.appendChild(_n), !0;
  }

  return !1;
}

export { t as polyfillCountryFlagEmojis };